<template>
    <!-- pagination for in-line paginated photos, like photos for album-location -->
    <nav class="pagination is-right" role="navigation" aria-label="pagination">
        <ul class="pagination-list">
            <li v-if="pagination.current_page > 1">
            <a class="pagination-previous" aria-label="First" @click.prevent="onChange(1)"><span aria-hidden="true">««</span></a>
            <a class="pagination-previous" aria-label="Previous" @click.prevent="onChange(pagination.current_page - 1)"><span aria-hidden="true">«</span></a>
            </li>

            <li v-for="page in pagesNumber" :class="getClass(page)">
            <!-- <li v-for="page in pagesNumber" :class="{'is-active': page == pagination.current_page}"> -->
                <a aria-label="Next" href="#" @click.prevent="onChange(page)">{{ page }}</a>
            </li>

            <li v-if="pagination.current_page < pagination.last_page">
                <a class="pagination-next" @click.prevent="onChange(pagination.current_page + 1)"><span aria-hidden="true">»</span></a>
                <a class="pagination-next" @click.prevent="onChange(pagination.last_page)"><span aria-hidden="true">»»</span></a>
            </li>
        </ul>
        <!-- <p class="is-left" v-if="currentPage !== ''"> Current Page: {{ currentPage }} </p> -->
    </nav>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name:'app-pagination',
    props: {
        offset: {
            type: Number,
            default: 4
        }
    },
    data() {
        return {
            currentPage: '',
        };
    },

    computed: {
        ...mapGetters([
            'items',
            'paginate',
            'pagination',
            'error'
        ]),

        pagesNumber() {
            /*let mid;
            let range = [];*/
            // if only one page, hide pagination
            if (this.pagination.current_page=== 1 && this.pagination.current_page === this.pagination.last_page) {
                return;
            }
            if (!this.pagination.to) {
                return [];
            }
            let from = this.pagination.current_page - this.offset;
            if (from < 1) {
                from = 1;
            }
            let to = from + (this.offset * 2);
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
            }
            let pagesArray = [];
            for (from = 1; from <= to; from++) {
                pagesArray.push(from);
            }

            /*range.forEach(function (from) {
                if(mid) {
                    if(from - mid === 2) {
                        console.log('mid - from === 2');
                        pagesArray.push(mid+1);
                    } else if (from - mid !== 1){
                        console.log('from - mid not 1');
                        pagesArray.push('...');
                    }
                }
                pagesArray.push(from);
                mid = from;
            });*/
            return pagesArray;
        }
    },

    methods: {
        ...mapActions([
            'setPaginationCurrentPage',
        ]),

        onChange(page) {
            this.$store.dispatch('setPaginationCurrentPage', page);
            this.currentPage = page;
        },

        getClass (item) {
          return this.pagination.current_page !== item ? 'pagination-link' : 'pagination-link is-current';
        },
    },
    mounted() {
        // console.log('pagination prevent - Component mounted.');
    },
}

</script>

<style lang="scss">
    @import '../../../style/app.scss';
    .pagination-next, .pagination-previous {
        border-color: transparent !important;
    }
    .pagination-list {
        justify-content: flex-end;
        order: 3;
        margin-top: 70px;
    }
    .pagination-link {
        border-color: transparent !important;
        border: none;
        min-width: 1.25em !important;
        padding: 0 !important;
        margin: 0.25rem 0 !important;
        &.is-current {
            background: transparent !important;
            border-color: transparent;
            border-bottom: 1px solid $limegreen !important;
            a {
                color: $link-active !important;
                font-weight: bold;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/elements/pagination/PaginationPrevent.vue